import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-weight: 100;
  font-size: 24px;
  margin-top: 10px;
`;

export const Text = styled.div`
  margin-right: 20px;
`;

export const Icon = styled.div`
  animation: spinWithStop 3s ease-out; /* Adjust duration and easing */
  animation-iteration-count: infinite;

  // from center
  transform-origin: 50% 50%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  @keyframes spinWithStop {
    0% {
      transform: rotate(0deg);
    }
    80% {
      transform: rotate(720deg); /* Adjust to spin multiple times */
    }
    100% {
      transform: rotate(720deg); /* Stops at final rotation */
    }
  }
`;
